module.exports = __webpack_public_path__ + "img/weddingbands.6d82184.webp";